import React from "react";
import CategoryForm from "../CategoryForm";

const AddCategory = () => {
  return <CategoryForm title="Adicionar categoria" />;
};

export default AddCategory;
